import React from 'react';

const SalesReportHeader = () => (
    <h1>Sales Report</h1>
);

export default SalesReportHeader;
